import { useTranslation } from 'react-i18next';
import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import { useGetCargoItems } from 'api/cargo-items/use-get-cargo-items.ts';
import type { CargoItemRes, CargoItemStatusRes } from 'api/swagger';
import { useTransformToTableData } from 'shared/hooks/use-transform-to-table-data';
import { CargoItemStatus } from 'components/cargos/cargo-item-status';
import styles from 'components/cargos/cargos-list/cargos-list.module.scss';
import { CargoItemsController } from './components/cargo-items-controller';
import type { ICargoItemsTableProps } from './types';

export const CargoItemsTable = (props: ICargoItemsTableProps) => {
  const { cargoId, cargoType } = props;
  const { t } = useTranslation();

  const { data: cargoItems, isLoading } = useGetCargoItems({ cargoId });
  const tableData = useTransformToTableData(cargoItems?.data || []);

  const columns: ColumnsType<CargoItemRes> = [
    { title: 'ID', dataIndex: 'compositeId', key: 'compositeId' },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status: CargoItemStatusRes) => {
        return <CargoItemStatus type={status.type} from={status.fromWarehouseId} to={status.toWarehouseId} />;
      },
    },
    { title: t('cargo:length_label'), dataIndex: 'length', key: 'length' },
    { title: t('cargo:width_label'), dataIndex: 'width', key: 'width' },
    { title: t('cargo:height_label'), dataIndex: 'height', key: 'height' },
    { title: t('cargo:stacks_label'), dataIndex: 'stack', key: 'stack' },
    {
      title: t('cargo:weight_label'),
      dataIndex: 'weight',
      key: 'weight',
      render: (weight: number) => {
        return weight ? weight : <span className={styles.red}>0</span>;
      },
    },
    { title: t('cargo:ldm_label'), dataIndex: 'LDM', key: 'LDM' },
    { title: t('cargo:volume_label'), dataIndex: 'volume', key: 'volume' },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      render: (_, cargoItem: CargoItemRes) => {
        return (
          <CargoItemsController
            cargoItem={cargoItem}
            cargoType={cargoType}
            isLastItem={!cargoItems?.data.length || cargoItems?.data.length <= 1}
          />
        );
      },
    },
  ];

  return (
    <Table
      className={styles.expandedTable}
      loading={isLoading}
      columns={columns}
      dataSource={tableData}
      pagination={false}
    />
  );
};
